import {AfterViewInit, OnDestroy, OnInit} from '@angular/core';
import {FeatureTypeService} from '@catmodules/core/services/index';
import {BaseWelcomeComponent} from 'app/shared/feature/create-form-wizards/base-welcome.component';
import {Subscription} from "rxjs";

/**
 * Abstract component to provide common helpful utils for handling model
 * data which requires the current active Feature model in its scope
 *
 */
export abstract class BaseFeatureWelcomeComponent
  extends BaseWelcomeComponent
  implements AfterViewInit, OnInit, OnDestroy {
  feature = null;
  featureSubscription: Subscription;

  /**
   * Initiates a subscription to the currently available Feature model.
   * Executes an event for every time the current Feature was changed
   *
   * @param {FeatureTypeService} featureService
   */
  constructor(private featureService: FeatureTypeService) {
    super();
  }

  ngOnInit() {
    this.featureSubscription = this
      .featureService
      .getCurrent()
      .subscribe((feature) => {
        this.feature = feature;
        this.afterFeatureChanged(this.feature);
      });
  }

  ngOnDestroy() {
    this.featureSubscription.unsubscribe();
  }

  /**
   * Returns the current FeatureService instance
   * @returns {FeatureTypeService}
   */
  getFeatureService() {
    return this.featureService;
  }

  /**
   * Returns the current available Feature
   * @returns {any}
   */
  getFeature() {
    return this.feature;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/shared/feature/create-form-wizards/base-feature-welcome.component.ts